var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStep4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 72,
    viewBox: "0 0 64 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 72,
    rx: 12,
    fill: "#F3F6F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3179 40L31.2859 25.6H35.4459L27.2859 40H23.3179ZM23.3179 42.24V40L24.8859 38.944H40.6939V42.24H23.3179ZM33.9419 48V33.344H37.5579V48H33.9419Z",
    fill: "#4E5667"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep4);
export default __webpack_public_path__ + "static/media/step-4.dc525737cf7c27e1b6b57df652607cf8.svg";
export { ForwardRef as ReactComponent };